// Improve product card behavior on touch devices
document.addEventListener('DOMContentLoaded', function() {
  // Only for touch devices
  if ('ontouchstart' in window) {
    const cardLinks = document.querySelectorAll('.card-link');

    cardLinks.forEach(link => {
      // Show hover image immediately on touch start
      link.addEventListener('click', function(e) {
        const hoverImage = this.querySelector('.card-image__hover');
        if (hoverImage) {
          hoverImage.style.opacity = '1';
        }

        setTimeout(() => {
          if (hoverImage) {
            hoverImage.style.opacity = '0';
          }
        }, 2000);
      });
    });
  }
});
